import BootstrapVue from 'bootstrap-vue';
import CardProduto from './vue-components/CardProduto';
import CalcCategoria from './vue-components/CalcCategoria';
import TabelaPrecos from './vue-components/TabelaPrecos';
import messenger from './vue-components/messenger';
import novochat from './vue-components/messenger-novochat';
import filters from './vue-filter';
import { vmax, vmin, vdefault } from './vue-directives';
import VueTheMask from 'vue-the-mask';
import money from 'v-money';
Vue.use(BootstrapVue);
Vue.use(money, { precision: 2, prefix: 'R$ ', decimal: '.', thousands: ',' });
Vue.use(VueTheMask);
Vue.filter('currency', filters.currency);
Vue.component('card-produto', CardProduto);
Vue.component('calc-categoria', CalcCategoria);
Vue.component('tabela-precos', TabelaPrecos);
Vue.component('messenger', messenger);
Vue.component('novochat', novochat);

Vue.directive('min', vmin);
Vue.directive('max', vmax);
Vue.directive('default', vdefault);



// WEBPACK FOOTER //
// ./resources/assets/js/loja/app.js